import { makeStyles } from "@material-ui/core";

export const userRendererStyles = makeStyles(theme => ({
  root: {
    minHeight: 270,
    border: "1px solid #ddd",
    boxShadow: "0px 0px 19px -2px rgb(163 163 163 / 30%)",
    borderRadius: 3,
  },
  header: {
    paddingBottom: 5,
    paddingTop: 10,
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cardContent: {
    padding: 15,
    paddingTop: 45,
  },
  cardHeading: {
    color: "#9f9f9f",
    fontSize: "1.1em",
    fontWeight: 600,
  },
  centerHeader: {
    textAlign: "center",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    fontWeight: "bold",
    color: "#9f9f9f",
  },
  centerHeaderMain: {
    textAlign: "center",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    fontWeight: "bold",
    fontSize: "6rem",
    color: "#9f9f9f",
  },
  countAvatar: {
    height: 60,
    width: 60,
  },
  countCaption: {
    color: "#9f9f9f",
    // fontSize: "0.9em",
    fontWeight: 500,
    textAlign: "center",
  },
  red: {
    backgroundColor: "#B84F46",
  },
  green: {
    backgroundColor: "#5F8649",
  },
  amber: {
    backgroundColor: "#E6B03A",
  },
  chip: {
    width: 50,
    color: "white",
  },
  listText: {
    marginLeft: "10px",
  },
}));
